import { DashboardPage } from "./DashboardContainer";

export default DashboardPage;
